import { CheckboxOption } from 'shared/components';

import makeClasses from './CheckboxOptCustom.style';

import type { CheckboxOptionProps } from 'shared/components';

export function CheckboxOptCustom(props: CheckboxOptionProps) {
  const _classes = makeClasses();
  return (
    <CheckboxOption
      variant='default'
      labelPlacement='end'
      classes={{
        formControlLabel: {
          root: _classes.checkboxOptionRoot,
          label: _classes.checkboxOptionLabel,
        },
      }}
      checkboxProps={{
        classes: { root: _classes.checkboxRoot },
      }}
      {...props}
    />
  );
}
